var Avatar = require('avatar');


var AvatarUploadView = Backbone.View.extend({
    tagName: 'form',
    className: 'avatarUploadForm',
    input: null,
    events: {
        'submit': 'submit',
        'click input[type=file]': 'inputClick',
        'change input': 'inputChange'
    },
    initialize: function (options, input) {
        this.uploading = null;
        
        this.model.bind('avatarUploadPrompt', this.prompt, this);
        this.model.bind('finaliseAvatarFromPromise', this.finaliseAvatarFromPromise, this);
    },
    inputClick: function (e) {
        e.stopPropagation();
    },
    inputChange: function (e) {
        var files = this.file[0].files;
        this.doUpload(files);
    },
    doUpload: function (files) {
        if (this.uploading) {
            this.uploading.cancelUpload();
        }
        if (files && files[0]) {
            var file = files[0];
            if (file.size > 0) {
                var avatar = Avatar.fromFile(file, this.model.session);
                if (!avatar.isAcceptableType()) {
                    this.model.trigger('postError', {message: 'invalid_file_type'});
                } else if (avatar.isTooLarge()) {
                    this.model.trigger('postError', {message: 'file_too_large'});
                } else {
                    this.model.trigger('avatarPreview', this.target, avatar, this.options);
                }
            }
        }
        this.clear();
    },
    prompt: function (target, options) {
        this.options = options || {};
        this.target = target;
        this.file.click();
    },
    submit: function (e) {
        e.preventDefault();
    },
    render: function () {
        var labelId = 'avatarUploadView';
        this.label = $('<label class="g">').text('Upload a file').attr('for', labelId);
        this.file = $('<input class="g" name="file" type="file" accept="image/*" tabindex="-1" aria-hidden="true">').attr('id', labelId);
        $(this.el).append(this.label);
        $(this.el).append(this.file);
        
        return this;
    },
    clear: function () {
        this.file.val('');
    },
    val: function () {
        return this.file.val();
    },
    finaliseAvatarFromPromise: function (avatar, dataUrl) {
        this.uploading = avatar;
        
        // Background upload
        var uploadPromise = avatar.upload().always(_.bind(function () {
            this.uploading = null;
        }, this));
        
        var finalisePromise = new $.Deferred();

        avatar.set(this.options.properties);
        
        this.model.trigger('avatarUpload', avatar, dataUrl, uploadPromise, finalisePromise);
        
        uploadPromise.done(_.bind(function (uploadResponse) {
            avatar.finalise({}, _.bind(function (finaliseResponse) {
                if (finaliseResponse.success) {
                    finalisePromise.resolve();
                } else {
                    finalisePromise.reject(finaliseResponse);
                }
            }, this));
        }, this)).fail(_.bind(function (errorString, errorResponse) {
            if (errorString != 'abort') {
                // Can be missing a response if an error was returned before all data was uploaded
                errorResponse = errorResponse || {message: 'upload_error'};
                finalisePromise.reject(errorResponse);
            } else {
                finalisePromise.reject();
            }
        }, this));
    }
});

module.exports = AvatarUploadView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/avataruploadview.js
// module id = ayOX
// module chunks = 1